import React from 'react';
import Back from "../images/icons/Back.png";
import User from "../images/icons/Profile.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from 'react';
import { navigateBack } from "../../../utils/navigationRules";
const Header:React.FC=()=> {
  const location = useLocation();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const reportIdx = pathSegments.findIndex(
    (s) =>
      s === 'session-report' ||
      s === 'session-analytics' ||
      s === 'trainers-report',
  );
  const titleSegments =
    reportIdx >= 0 ? pathSegments.slice(0, reportIdx + 1) : pathSegments;
  const formattedTitle = titleSegments
    .map((segment) => {
      if (segment === 'trainers-report') return 'Session Report';
      return segment
        .replaceAll('-', ' ')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
    })
    .join(' > ');

  const logoutHandler = () => {
    sessionStorage.clear();
    navigate('/');
  };

  return (
    <div className='pe-2'>
      <div className="container-fluid bg-white border rounded-2 p-3 d-flex justify-content-between me-5">
        <span className="text-center fs-6">
          <img
            src={Back}
            alt="Back btn"
            className="me-1"
            onClick={() => navigateBack(navigate, location.pathname)}
            role="button"
          />
          {formattedTitle.replace("Trainer > ", "").replace("Reports","Performance Analysis")}
        </span>
        <div
          className="position-relative"
          onMouseEnter={() => setShowDropdown(true)}
          onMouseLeave={() => setShowDropdown(false)}
          style={{ cursor: 'pointer' }}
        >
          <img className="me-2" src={User} alt="User" />

          {showDropdown && (
            <div
              className="position-absolute bg-white border rounded shadow p-2"
              style={{
                right: 0,
                top: '100%',
                minWidth: '120px',
                zIndex: 1000
              }}
            >
              <div
                className="dropdown-item text-dark"
                style={{ cursor: 'pointer' }}
                onClick={logoutHandler}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
